export const VIDEO_URLS = {
  video0: "https://d12kahz818c96x.cloudfront.net/prelander/flirto-1-slide.webm",
  video1: "https://d12kahz818c96x.cloudfront.net/prelander/flirto-2-slide.webm",
  video3: "https://d12kahz818c96x.cloudfront.net/prelander/flirto-3-slide.webm",
  video4: "https://d12kahz818c96x.cloudfront.net/prelander/flirto-4-slide.webm",
};
